import { toast } from '@/shared/utils/UIHelper'
import accountRepository from '@/shared/http/repositories/access/account.js'

export default {
  name: 'LostPassword',
  data () {
    return {
      username: null
    }
  },
  methods: {
    onResetPassword () {
      if (this.username) {
        const data = {
          'username': this.username
        }
        accountRepository.ResetPassword(data)
          .then((response) => {
            if (response.status === 200) {
              console.log('senha resetada')
            } else {
              toast.error('Não foi possível alterar a senha')
            }
          })
        toast.success('<strong>Senha redefinida com sucesso!</strong><br><br>As informações foram enviadas para seu email!')
        this.email = null
      } else {
        toast.error('ATENÇÃO! Informe seu nome de usuário')
      }
    },
    handleBackToLogin () {
      this.$emit('BackToLogin')
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/public/auth/lost/LostPassword.js